import React, { useState, useEffect } from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import amuIconLogo from '../assets/amuIconLogo.png'
import Loader from './common/Loader';
export default function Header({ PageHandler }) {

    const [loader, setLoader] = useState(false)
    const [dropdown, setDropdown] = useState(false)
    const [adminData, setadminData] = useState({})
    const handleDropdown = () => {
        setDropdown(!dropdown)
    }

    useEffect(() => {

        const login = window.sessionStorage.getItem("AdminLogin")
        const ParsedData = JSON.parse(login)
        setadminData(ParsedData)
    }, [])

    const selectedDropdown = () => {
        setLoader(true)
        window.sessionStorage.removeItem("AdminLogin")
        window.sessionStorage.removeItem("SearchData")
        handleDropdown()
        PageHandler("login")
        setLoader(false)
    }
    return (
        <>
            <div className="Header">
                {
                    loader ?
                    <Loader/> :''
                }
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-4">
                            <img src={amuIconLogo} width={"27px"} style={{ marginLeft: '10px' }} />
                        </div>
                        <div className="col-sm-4"></div>
                        <div className="col-sm-4 d-flex justify-content-end">
                            <div className="inputGrps">
                                <KeyboardArrowDownIcon className='select_input' onClick={(e) => handleDropdown(e)} />
                                {
                                    dropdown ?
                                        <div className="dropdownMenu">
                                            <h6 onClick={(e) => selectedDropdown(e)}>SIGN OUT</h6>
                                        </div>
                                        : ""
                                }
                                <h6 className='username' onClick={(e) => handleDropdown(e)}>{adminData?.email || ""}</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
